import React from 'react';
import UniversalBlock from '../components/UniversalBlock';
import styles from './SideStyle.module.scss';
import { useSelector } from 'react-redux';
import { isBlockChoosen } from './helpers/isBlockChoosen';

function BottomSide({ feet }) {
	const { damagesList, selectedSide, entryOneReport } = useSelector((state) => state.containerAccept);
	const { placement_code_description } = selectedSide;

	return (
		<div className={styles.mainBlock_U}>
			<div className={styles.mapRowNumber_U}>
				<p className={styles.topNumber_new}></p>
				{placement_code_description[0].parts[entryOneReport.container.size_display === '20' ? '20-feet' : '40-feet']
					.slice()
					.map((part) => (
						<p key={part} className={styles.topNumber_new}>
							{part}
						</p>
					))}
			</div>
			{placement_code_description.map(({ option, parts }) => (
				<div key={option} className={styles.mapRow_new}>
					<div className={styles.mapNoOptionRow}>
						<p className={styles.sideLabel_new}>R</p>
						<p className={styles.sideLabel_new}>L</p>
					</div>
					{parts[entryOneReport.container.size_display === '20' ? '20-feet' : '40-feet'].slice().map((part, index) => (
						<UniversalBlock
							key={index}
							type={getType(option, part)}
							sideIndex={'U'}
							sideName={'Низ'}
							divider={option}
							part={part.toString()}
							partCode={getPartCode(option, part)}
							choosen={isBlockChoosen(damagesList, 'U', option, part.toString())}
						/>
					))}
				</div>
			))}
		</div>
	);
}

function getType(option, part) {
	if (option === 'LR' || option === 'R') {
		if (
			[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30].includes(part)
		) {
			return 'mainPanel_U';
		}
	}
}

function getPartCode(option, part) {
	return `${option}-${part}`;
}

export default BottomSide;
